import { Heading, Button } from "@chakra-ui/react";
import { TbMoodEmpty } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { Card } from "./Card";

interface NoItemCardProps {
  navigateUrl?: string;
  buttonText: string;
  description: string;
  onButtonClick?: () => void;
}

export const NoItemCard = ({
  navigateUrl,
  buttonText,
  description,
  onButtonClick,
}: NoItemCardProps) => {
  const navigate = useNavigate();
  return (
    <Card display={"flex"} flexDir={"column"} alignItems={"center"} padding={4}>
      <TbMoodEmpty size={70} />
      <Heading marginBottom={4} fontSize={"x-large"}>
        {description}
      </Heading>
      <Button
        colorScheme={THEME_COLOR_SCHEME}
        onClick={onButtonClick ?? (() => navigate(navigateUrl ?? ""))}
      >
        {buttonText}
      </Button>
    </Card>
  );
};
